import { render, staticRenderFns } from "./termCondition.vue?vue&type=template&id=9be5e8f6&"
import script from "./termCondition.vue?vue&type=script&lang=js&"
export * from "./termCondition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBreadcrumbLink: require('@chakra-ui/vue').CBreadcrumbLink, CBreadcrumbItem: require('@chakra-ui/vue').CBreadcrumbItem, CBreadcrumb: require('@chakra-ui/vue').CBreadcrumb, CHeading: require('@chakra-ui/vue').CHeading, CText: require('@chakra-ui/vue').CText, CBox: require('@chakra-ui/vue').CBox})
